import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import {
  MailContentModel,
  StandardResponseModel,
} from '../../../core/models/standard-response.model'

@Injectable({
  providedIn: 'root',
})
export class StandardResponseService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl

  /**
   * Récupère les réponses standardisées disponibles pour un select
   * @param erpSource Source ERP (abm, nrj, etc.)
   */
  getForSelect(erpSource: string): Observable<StandardResponseModel[]> {
    const params = new HttpParams().set('erpSource', erpSource)
    return this.http
      .get<StandardResponseModel[] | { data: StandardResponseModel[] }>(
        `${this.planifyApiUrl}/standard-responses/select`,
        { params }
      )
      .pipe(
        // L'API peut renvoyer soit un tableau brut, soit une réponse
        // Laravel Resource enveloppée dans { data: [...] }. On normalise
        // toujours vers un tableau pour alimenter le p-select.
        map((response) =>
          Array.isArray(response) ? response : (response?.data ?? [])
        )
      )
  }

  /**
   * Récupère le contenu d'un mail avec une réponse standardisée
   * @param erpSource Source ERP (abm, nrj, etc.)
   * @param affairRef Référence MyLink de l'affaire
   * @param standardResponseId ID de la réponse standardisée
   * @param interventionId ID de l'intervention (optionnel)
   */
  getMailContent(
    erpSource: string,
    affairRef: string,
    standardResponseId: number,
    interventionId?: number
  ): Observable<MailContentModel> {
    const body = {
      erpSource,
      affairRef,
      standardResponseId,
      interventionId,
    }
    return this.http.post<MailContentModel>(
      `${this.planifyApiUrl}/standard-responses/mail-content`,
      body
    )
  }

  /**
   * Envoie un mail via la réponse standardisée
   * @param data Données du mail à envoyer
   */
  sendMail(data: {
    erpSource: string
    affairRef: string
    standardResponseId: number
    interventionId?: number
    subject: string
    content: string
    recipients: string[]
    files?: string[]
  }): Observable<{ status: number; message?: string; data?: any }> {
    return this.http.post<{ status: number; message?: string; data?: any }>(
      `${this.planifyApiUrl}/standard-responses/send-mail`,
      data
    )
  }
}
